import * as types from './mutation-types'
import {LOAD_QVCT_SURVEYS_CATEGORIES_WITHOUT_CHILDREN} from "./mutation-types";

export const loadSurveys = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/qvct/survey/collection', data).then((response) => {
            commit(types.LOAD_QVCT_SURVEYS, response.data.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}


export const loadQvctSurveyStats = ({ commit }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`get/qvct/survey/${id}/participation/statistics`).then((response) => {
            commit(types.LOAD_QVCT_SURVEY_STATS, { id, data: response.data })
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const loadQvctSurveyOpinion = ({ commit }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`/get/qvct/survey/${id}/response`).then((response) => {
            commit(types.LOAD_QVCT_SURVEY_OPINION, { id, data: response.data })
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}


export const loadQuestions = ({ commit }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`get/qvct/survey/form/${id}`).then((response) => {
            commit(types.LOAD_QVCT_SURVEY_QUESTIONS, {
                id: id,
                questions: response.data.fields
            })
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}


export const loadQvctSurveyResponses = ({ commit }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`get/qvct/survey/${id}/response/collection`).then((response) => {
            commit(types.LOAD_QVCT_SURVEY_RESPONSES, {
                id: id,
                responses: response.data.responses
            })
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}



export const loadQvctSurveyForResponse = ({ commit }, { id, mustBeActive }) => {
    return new Promise((resolve, reject) => {
        window.axios .get(`get/qvct/survey/form/field/${id}/${mustBeActive}`).then((response) => {
            commit(types.LOAD_QVCT_SURVEY_FROM_FOR_RESPONSE, response.data.qvctSurvey)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const saveQvctSurveyForResponse = ({ commit }, {id, data}) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`submit/qvct/survey/response/${id}`, data).then((response) => {
            /*commit(types.LOAD_QVCT_SURVEY_FROM_FOR_RESPONSE, response.data.qvctSurvey)*/
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const loadQvctSurvey = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`get/qvct/survey/detail/${data}`).then((response) => {
            commit(types.LOAD_QVCT_SURVEY, response.data.survey)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}



export const loadQvctSurveyCategoriesWithoutChildren = ({ commit }) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/qvct/survey/categories/without/children').then((response) => {
            commit(types.LOAD_QVCT_SURVEYS_CATEGORIES_WITHOUT_CHILDREN, response.data.categories)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const loadQvctSurveyRootCategories = ({ commit }) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/qvct/survey/root/categories').then((response) => {
            commit(types.LOAD_QVCT_SURVEYS_ROOT_CATEGORIES, response.data.categories)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const loadAnswersTypes = ({ commit }) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/qvct/answers/type/collection').then((response) => {
            commit(types.LOAD_QVCT_SURVEYS_ANSWER_TYPE, response.data.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const storeSurvey = ({commit}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('store/qvct/survey', data).then((response) => {
            commit(types.ADD_QVCT_SURVEY, response.data.survey)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const storeQuestion = ({commit}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('store/qvct/survey/form/field', data).then((response) => {
            commit(types.ADD_QVCT_SURVEY_QUESTION, {
                id: data.qvct_survey_id,
                questions: response.data.response
            })
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const updateQuestion = ({commit}, {id, data}) => {
    return new Promise((resolve, reject) => {
        window.axios.patch(`update/qvct/survey/form/field/${id}`, data).then((response) => {
            commit(types.LOAD_QVCT_SURVEY_QUESTION, {
                id: data.qvct_survey_id,
                questions: response.data.fields
            })
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const deleteQuestion = ({commit}, {surveyId, id}) => {
    return new Promise((resolve, reject) => {
        window.axios.delete(`delete/qvct/survey/form/field/${id}`).then((response) => {
            commit(types.REMOVE_QVCT_SURVEY_QUESTION, {surveyId, id})
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}




export const updateSurvey = ({commit}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.patch(`update/qvct/survey/${data.id}`, data).then((response) => {
            commit(types.LOAD_QVCT_SURVEY, response.data.survey)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })

}

export const importQuestion = ({commit}, {surveyId, id}) => {
    return new Promise((resolve, reject) => {
        window.axios.post('import/qvct/survey/form/field', data).then((response) => {

            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const sendLinkMail = ({ commit }, { emails, surveyId }) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`/send/qvct/survey/link/${surveyId}`, { emails })
            .then(response => {
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const loadQvctSurveyStatus = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/qvct/survey/status/enum', data).then((response) => {
            commit(types.LOAD_QVCT_SURVEY_STATUS, response.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}


export const updateSurveyStatus = ({ commit }, { id, status }) => {
    return new Promise((resolve, reject) => {
        window.axios.patch(`change/qvct/survey/status/${id}`, { status })
            .then((response) => {
                resolve(response);
            })
            .catch((err) => {
                reject(err);
            });
    });
};
